import createReducer from '../createReducer'
import {
  RECOVER_PASSWORD,
  RECOVER_PASSWORD_SUCCESSFUL,
  RECOVER_PASSWORD_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILURE
} from './constants'

const initialState = {
  isSubmitting: false,
  isSuccess: false,
  login: undefined,
  userPhrase: undefined
}

const auth = createReducer(initialState, {
  [RECOVER_PASSWORD]: (state, action) => ({
    ...initialState,
    login: action.payload.login,
    isSubmitting: true
  }),
  [RECOVER_PASSWORD_SUCCESSFUL]: (state, action) => ({
    ...state,
    isSubmitting: false,
    userPhrase: action.payload.userPhrase
  }),
  [RECOVER_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isSubmitting: false
  }),
  [RESET_PASSWORD]: (state, action) => ({
    ...state,
    isSubmitting: true,
    isSuccess: false
  }),
  [RESET_PASSWORD_SUCCESSFUL]: (state, action) => ({
    ...state,
    isSubmitting: false,
    isSuccess: true
  }),
  [RESET_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isSubmitting: false,
    isSuccess: false
  })
})

export default auth
